<py-notification [type]="'danger'" [tiny]="tiny" [showBorder]="showBorder" [ngClass]="{ 'my-4': !tiny }">
  <h5>{{ 'accountingCodes.noAccountingCodesDefined_title' | cxTranslate }}</h5>
  <p>
    {{ 'accountingCodes.noAccountingCodesDefined_text' | cxTranslate }}
  </p>
</py-notification>
